import { createRoot } from 'react-dom/client'
import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material'
import App from './App.tsx'
import './index.css'
import { muiTheme } from './theme/muiTheme'
import { registerDynamicImportRecovery } from './utils/dynamic-import-recovery'
import { bootstrapDemoMode } from './demo/config'
import { installDemoFetchMock } from './demo/mockApi'

registerDynamicImportRecovery()
bootstrapDemoMode()
installDemoFetchMock()

createRoot(document.getElementById("root")!).render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </StyledEngineProvider>
);
